import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
    cardImgText: {
        position: "absolute",
        top: "45%",
        left: "30%",
        transform: "translateX(-50%)",
        textAlign: "center",
        color: "white",
        maxWidth: "100%",
      },
      root: {
        "&$selected": {
          backgroundColor: "#b2dfdb",
        },
        "&:hover": {
          backgroundColor: "#e0f2f1",
        },
        cursor: "pointer",
      }
  }));

  export default useStyles;